// contacts/actionTypes.js

const REQUEST_MENU_DATA = '@@contactList/REQUEST_MENU_DATA';
const MENU_DATA_RESPONSE = '@@contactList/MENU_DATA_RESPONSE';

export default {
    REQUEST_MENU_DATA,
    MENU_DATA_RESPONSE
};